import ApiDocumentProvider from "./ApiDocumentProvider";
import Document from "../../model/document/Document";
import IBimVisualizerApiProvider from "../bimVisualizerApi/IBimVisualizerApiProvider"
import IGbContext from "../../interfaces/IGbContext";
import CoreDocument from "../../model/document/CoreDocument";
import IContextDocument from "../../model/document/IContextDocument";

class ApiCoreDocumentProvider extends ApiDocumentProvider {
    
    protected context : IGbContext;
        
    constructor(    apiProvider: IBimVisualizerApiProvider, gbContext: IGbContext ) {
        super(apiProvider);
        this.context = gbContext;
    }
    
    getDocuments(): Promise<Document[]> {
        return this.apiProvider.getCoreDocuments(this.context);
    }

    getContextQueryParams(): IGbContext | undefined {
            return this.context;
    }
    
    toContextDocument(doc: Document): IContextDocument {
        return new CoreDocument(doc, this.context);
    }

    async createInitialDocument(): Promise<IContextDocument> {
        const newDoc = new CoreDocument(   new Document(`Document for apartment ${this.context.apartmentId}`), this.context);        
        newDoc.document.documentUuid = await this.apiProvider.addCoreDocument(newDoc.document.name, this.context) ?? "";        
        return newDoc;
    }   
}

export default ApiCoreDocumentProvider;
